import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import {
  ManagementContainerCostModel,
  ManagementContainerModel,
  ManagementContainerTypeModel,
  ManagementShipmentModel,
  ManagementVoyageModel,
} from '@data-layer/models/management';
import { ManagementVoyageOptimizationModel } from '../../../models';

@Component({
  selector: 'optimization-view',
  templateUrl: './optimization-view.component.html',
  styleUrls: ['./optimization-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptimizationViewComponent implements OnChanges {
  @Input() public voyage: ManagementVoyageModel;
  @Input() public containers: ManagementContainerModel[];
  @Input() public containerTypes: ManagementContainerTypeModel[];
  @Input() public containerBoxCosts: ManagementContainerCostModel[];
  @Output() public saveContainersShipping: EventEmitter<ManagementVoyageOptimizationModel[]> = new EventEmitter<
    ManagementVoyageOptimizationModel[]
  >();
  @Output() public createContainer: EventEmitter<number> = new EventEmitter<number>();
  @Output() public deleteContainer: EventEmitter<number> = new EventEmitter<number>();
  @Output() public moveShipmentSource: EventEmitter<{ shipmentId: number; referenceNumber: string }> = new EventEmitter<{
    shipmentId: number;
    referenceNumber: string;
  }>();

  public optimizationPreparation: ManagementVoyageOptimizationModel[] = [];

  constructor() {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (!changes.containers?.firstChange && changes.containers?.currentValue) {
      this.getColoadingTotals();
    }
  }

  //8
  public getGroupageTotals(): number {
    return this.nonDefaultContainers.reduce(
      (accTotals: number, currentContainer: ManagementContainerModel) => accTotals + this.getTotalCostContainer(currentContainer),
      0,
    );
  }

  //69
  public getContainerOpenBoxSum(containerTypeId: number): number {
    return (this.containerBoxCosts || []).find((item: ManagementContainerCostModel) => item.containerTypeId === containerTypeId)?.cost || 0;
  }

  //9
  public get totalBookedColoading(): number {
    let res: number = 0;
    this.containers.forEach((container: ManagementContainerModel) => {
      res += container.shipments.reduce((accPrice: number, currentShipment: ManagementShipmentModel) => {
        return accPrice + currentShipment?.aggregatedStatistics?.totalCost;
      }, 0);
    });
    return res;
  }

  //8a
  public getColoadingTotals(): number {
    return this.defaultContainer?.shipments.reduce((accPrice: number, currentShipment: ManagementShipmentModel) => {
      return accPrice + currentShipment?.aggregatedStatistics?.totalCost;
    }, 0);
  }

  //70
  public getTotalCostContainer(container: ManagementContainerModel): number {
    return container.cost;
    // return 1;
    // return (
    //   this.shipments.filter((shipment: ManagementShipmentModel) => shipment?.container?.containerTypeId === container.containerType.id)
    //     .length *
    //     this.getContainerSum(enumSubCostPricingType.PER_SHIPMENT, container.containerType) +
    //   this.getContainerSum(enumSubCostPricingType.PER_CONTAINER, container.containerType)
    // );
  }

  public moveShipment(shipmentToMoveData: { shipmentId: number; referenceNumber: string }): void {
    this.moveShipmentSource.emit(shipmentToMoveData);
  }

  public get defaultContainer(): ManagementContainerModel {
    return (this.containers || []).find(
      (item: ManagementContainerModel) =>
        item.containerType?.id === this.containerTypes.find((itemType: ManagementContainerTypeModel) => itemType.isDefault)?.id,
    );
  }

  public get nonDefaultContainers(): ManagementContainerModel[] {
    return (this.containers || []).filter(
      (item: ManagementContainerModel) =>
        item.containerType?.id !== this.containerTypes.find((itemType: ManagementContainerTypeModel) => itemType.isDefault)?.id,
    );
  }

  public get defaultContainerId(): number {
    return this.defaultContainer?.id;
  }

  public get defaultContainerType(): ManagementContainerTypeModel {
    return (this.containerTypes || []).find((itemType: ManagementContainerTypeModel) => itemType.isDefault);
  }

  public get nonDefaultContainerType(): ManagementContainerTypeModel[] {
    return (this.containerTypes || []).filter((itemType: ManagementContainerTypeModel) => !itemType.isDefault);
  }

  public containerShipments(containerId: number): ManagementShipmentModel[] {
    return (this.containers || []).find((item: ManagementContainerModel) => item.id === containerId)?.shipments || [];
  }

  public onCheckboxChecked(data: { shipmentId: number; isChecked: boolean }, oldContainerId: number): void {
    const { shipmentId, isChecked }: { shipmentId: number; isChecked: boolean } = data;

    const existingItem: ManagementVoyageOptimizationModel = this.optimizationPreparation.find(
      (item: ManagementVoyageOptimizationModel) => item.oldContainerId === oldContainerId,
    );

    if (!!existingItem) {
      if (isChecked) {
        existingItem.selectedShipmentIds.push(shipmentId);
      } else {
        existingItem.selectedShipmentIds = existingItem.selectedShipmentIds.filter((item: number) => item !== shipmentId);
      }
    } else {
      this.optimizationPreparation.push({ oldContainerId, newContainerId: null, selectedShipmentIds: [shipmentId] });
    }
  }

  public saveContainersOptimization(newContainerId: number): void {
    const data: ManagementVoyageOptimizationModel[] = this.optimizationPreparation.map((item: ManagementVoyageOptimizationModel) => ({
      ...item,
      newContainerId,
    }));

    this.saveContainersShipping.emit(data);
    this.optimizationPreparation = [];
  }
}
